import { render } from "./AdminOrderCreate.vue?vue&type=template&id=51bb3858&scoped=true&ts=true&lang=true"
import script from "./AdminOrderCreate.vue?vue&type=script&lang=ts"
export * from "./AdminOrderCreate.vue?vue&type=script&lang=ts"

import "./AdminOrderCreate.vue?vue&type=style&index=0&id=51bb3858&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51bb3858"]])

export default __exports__